import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';

import type { Store } from '../../../store/list/types';

export const onItemsPerPageSet = (store: Store, newItemsPerPage: number | string): void => {
  const { setItemsPerPage } = store.getState();
  const itemsPerPage =
    typeof newItemsPerPage === 'string' ? newItemsPerPage : newItemsPerPage.toString();
  const parsedItemsPerPage = parseInt(itemsPerPage, 10);

  setItemsPerPage(parsedItemsPerPage);
  LocalStorage.set('recordingsItemsPerPage', parsedItemsPerPage);
};
